export default __webpack_public_path__ + "static/media/winningHackathons.png.webp";